export const TYPES = {
  SET_ORDER_BAILIFF_ALL: "order_bailiff/SET_ORDER_BAILIFF_ALL",
  SET_ORDER_BAILIFF_OPEN_ADD: "order_bailiff/SET_ORDER_BAILIFF_OPEN_ADD",
  SET_ORDER_BAILIFF_OPEN_EDIT: "order_bailiff/SET_ORDER_BAILIFF_OPEN_EDIT",
  SET_ORDER_BAILIFF_SELECTED: "order_bailiff/SET_ORDER_BAILIFF_SELECTED",
  SET_ORDER_BAILIFF_SEARCH: "order_bailiff/SET_ORDER_BAILIFF_SEARCH",
  //
  SET_ORDER_BAILIFF_QR: "order_bailiff/SET_ORDER_BAILIFF_QR",
  SET_ORDER_BAILIFF_OPEN_PAYMENT:
    "order_bailiff/SET_ORDER_BAILIFF_OPEN_PAYMENT",
};
